/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssetPiracyAssetPiracyProtocolsCreateAssetRequest,
  AssetPiracyAssetPiracyProtocolsDeleteAssetRequest,
  AssetPiracyAssetPiracyProtocolsGetAllAssetListResponse,
  AssetPiracyAssetPiracyProtocolsGetAssetImagesResponse,
  AssetPiracyAssetPiracyProtocolsGetAssetListRequest,
  AssetPiracyAssetPiracyProtocolsGetAssetListResponse,
  AssetPiracyAssetPiracyProtocolsGetAssetRequest,
  AssetPiracyAssetPiracyProtocolsGetAssetResponse,
  AssetPiracyAssetPiracyProtocolsGetPresignedUrlResponse,
  AssetPiracyAssetPiracyProtocolsUpdateAssetRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AssetPiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AssetPiracy
   * @name PiracyCreateAssetCreate
   * @request POST:/asset/piracy/create_asset
   */
  piracyCreateAssetCreate = (data: AssetPiracyAssetPiracyProtocolsCreateAssetRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/piracy/create_asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AssetPiracy
   * @name PiracyPresignedList
   * @request GET:/asset/piracy/presigned
   */
  piracyPresignedList = (params: RequestParams = {}) =>
    this.http.request<AssetPiracyAssetPiracyProtocolsGetPresignedUrlResponse, any>({
      path: `/asset/piracy/presigned`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AssetPiracy
   * @name PiracyGetAssetCreate
   * @request POST:/asset/piracy/get_asset
   */
  piracyGetAssetCreate = (data: AssetPiracyAssetPiracyProtocolsGetAssetRequest, params: RequestParams = {}) =>
    this.http.request<AssetPiracyAssetPiracyProtocolsGetAssetResponse, any>({
      path: `/asset/piracy/get_asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AssetPiracy
   * @name PiracyDeleteAssetCreate
   * @request POST:/asset/piracy/delete_asset
   */
  piracyDeleteAssetCreate = (data: AssetPiracyAssetPiracyProtocolsDeleteAssetRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/piracy/delete_asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AssetPiracy
   * @name PiracyUpdateAssetCreate
   * @request POST:/asset/piracy/update_asset
   */
  piracyUpdateAssetCreate = (data: AssetPiracyAssetPiracyProtocolsUpdateAssetRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/piracy/update_asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AssetPiracy
   * @name PiracyGetAssetListCreate
   * @request POST:/asset/piracy/get_asset_list
   */
  piracyGetAssetListCreate = (data: AssetPiracyAssetPiracyProtocolsGetAssetListRequest, params: RequestParams = {}) =>
    this.http.request<AssetPiracyAssetPiracyProtocolsGetAssetListResponse, any>({
      path: `/asset/piracy/get_asset_list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AssetPiracy
   * @name PiracyGetAllAssetListList
   * @request GET:/asset/piracy/get_all_asset_list
   */
  piracyGetAllAssetListList = (params: RequestParams = {}) =>
    this.http.request<AssetPiracyAssetPiracyProtocolsGetAllAssetListResponse, any>({
      path: `/asset/piracy/get_all_asset_list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AssetPiracy
   * @name PiracyGetAssetImagesList
   * @request GET:/asset/piracy/get_asset_images
   */
  piracyGetAssetImagesList = (params: RequestParams = {}) =>
    this.http.request<AssetPiracyAssetPiracyProtocolsGetAssetImagesResponse, any>({
      path: `/asset/piracy/get_asset_images`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
